import { PAN_SIZE } from '../constants';
import { FrameApplePayIncomingMessageType, PaymentMethodType } from '../types';
var VALID_DOMAIN_SFX = ['ru', 'com', 'com.tr', 'kz', 'by', 'uz'];
export function getDomainSfx() {
    var validHostnameRe = /(^|.+\.)yandex\.(.+)$/;
    if (typeof window !== 'undefined' &&
        window &&
        window.location &&
        window.location.hostname) {
        var match = window.location.hostname.match(validHostnameRe);
        if (match && VALID_DOMAIN_SFX.includes(match[2])) {
            return match[2];
        }
    }
    return 'ru';
}
export function fixDomainSfx(url, domainSfx) {
    if (!VALID_DOMAIN_SFX.includes(domainSfx)) {
        return url;
    }
    var validUrl = /^(https:\/\/trust(-test)?\.yandex)\.ru\//;
    return url.replace(validUrl, "$1.".concat(domainSfx, "/"));
}
var VALID_LANG_CODES = [
    'az',
    'be',
    'en',
    'et',
    'fi',
    'he',
    'hy',
    'ka',
    'kk',
    'ky',
    'lv',
    'ro',
    'ru',
    'tr',
    'uk',
    'uz'
];
var DEFAULT_LANG_CODE = 'ru';
var DOMAIN_SFX_LANG_MAP = {
    by: 'be',
    ua: 'uk',
    com: 'en',
    kz: 'kk',
    uz: 'uz',
    'com.tr': 'tr'
};
export function verifyLang(_lang) {
    var lang = typeof _lang === 'string' ? _lang.toLowerCase() : '';
    if (VALID_LANG_CODES.includes(lang)) {
        return lang;
    }
    return DEFAULT_LANG_CODE;
}
export function langByDomainSfx(domainSfx) {
    if (DOMAIN_SFX_LANG_MAP[domainSfx]) {
        return verifyLang(DOMAIN_SFX_LANG_MAP[domainSfx]);
    }
    return DEFAULT_LANG_CODE;
}
export var sleep = function (ms) { return new Promise(function (r) { return setTimeout(r, ms); }); };
export var isMethodIdCard = function (id) { return id.startsWith('card-'); };
export var isMethodIdSbp = function (id) { return id.startsWith('sbp-'); };
export var isCard = function (method) {
    return method.type === PaymentMethodType.card;
};
export var isSbpToken = function (method) {
    return method.type === PaymentMethodType.sbpToken;
};
export var isFrameStartApplePayMessage = function (message) {
    return message.type === FrameApplePayIncomingMessageType.start;
};
var addMask = function (_, start, end) {
    var mask = '*'.repeat(PAN_SIZE - start.length - end.length);
    return "".concat(start).concat(mask).concat(end);
};
export var formatCardNumber = function (str) {
    return str
        .replace(/\s/g, '')
        .replace(/(\d+)\*+(\d+)/, addMask)
        .replace(/([*\d]{4})/g, '$1 ')
        .trim();
};
